import { Dialog, Transition } from '@headlessui/react';
import { IconPrinter, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { useRef } from 'react';
import { Fragment } from 'react';
import ReactToPrint from 'react-to-print';
import { imageBaseUrl } from '../../config/http';
import ImageComponent from '../../utils/ImageComponent';
import PrintSuratTrxPenjualan from './PrintSuratTrxPenjualan';
import TestingPrint from './TestingPrint';
import SuratKeruak from './SuratKeruak';
import SuratToko from '../../components/surat/SuratToko';

export default function DetailBarangPenjualan({ closeModal, label, detailPenjualan, isOpen, isTertunda }) {
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const [openImage, setOpenImage] = useState(false);
  const [load, setLoad] = useState(false);

  const compSurat = useRef();
  function fake() { }

  const harga_modal_jual = detailPenjualan?.total_harga / detailPenjualan?.item?.berat;
  const tipe_surat = localStorage.getItem('tipe_surat');

  const tgl = String(detailPenjualan?.item?.created_at).split(' ');
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => { }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity" />
          </Transition.Child>
          {/* {tipe_surat === '1' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <PrintSuratTrxPenjualan isOpen={isOpen} detailPenjualan={detailPenjualan} />
            </div>
          ) : (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <TestingPrint isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            </div>
          )} */}
          {tipe_surat === '1' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <PrintSuratTrxPenjualan isOpen={isOpen} detailPenjualan={detailPenjualan} />
            </div>
          ) : tipe_surat === '2' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <TestingPrint isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            </div>
          ) : tipe_surat === '3' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <SuratKeruak isOpen={isOpen} detailPenjualan={detailPenjualan} />
            </div>
          ) : tipe_surat === '4' ? (
            <div ref={compSurat} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
              <SuratToko isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            </div>
          ) : null}
          {openImage && isOpen && (
            <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20  flex flex-col items-center justify-center">
              <div
                onClick={() => setOpenImage(false)}
                className={'absolute top-52 right-7 lg:top-16 lg:right-[280px] md:right-[120px] md:top-28 '}
              >
                <div className="bg-white p-2 rounded-full cursor-pointer hover:bg-white/50">
                  <IconX />
                </div>
              </div>
              <div>
                {!load && (
                  <div className="max-w-[48px] max-h-[48px]  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
                )}
                <img
                  onLoad={() => setLoad(true)}
                  width={''}
                  className={'lg:w-[700px] md:w-[500px] w-[350px] scale-50'}
                  height={''}
                  src={
                    detailPenjualan.item?.gambar1 === null
                      ? ''
                      : `${imageBaseUrl}${detailPenjualan.item?.gambar1[0].asli}`
                  }
                />
              </div>
            </div>
          )}
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-xl bg-white dark:bg-slate-900 border dark:border-slate-700 p-4 sm:p-6 text-left align-middle shadow-xl transition-all">
                  {/* Close Button - Absolute Positioned */}
                  <button
                    onClick={closeModal}
                    className="absolute top-4 right-4 p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:text-slate-300 dark:hover:bg-slate-800 transition-all z-10 focus:outline-none focus:ring-2 focus:ring-amber-500/20"
                    title="Tutup"
                  >
                    <IconX size={20} stroke={2.5} />
                  </button>

                  <div className="flex flex-col sm:flex-row items-start justify-between border-b border-slate-100 dark:border-slate-700/50 pb-3 mb-4 pr-8 sm:pr-0">
                    <Dialog.Title as="h2" className="text-xl font-bold leading-6 text-slate-900 dark:text-slate-100">
                      {label}
                      <span className="text-sm font-normal text-slate-500 dark:text-slate-400 mt-1.5 block leading-relaxed">
                        KODE FAKTUR : <span className="font-semibold text-amber-700 dark:text-amber-500 tracking-tight">{detailPenjualan?.kode_trx}</span>
                        <span className="hidden sm:inline mx-1.5 text-slate-300 dark:text-slate-600">|</span>
                        <span className="block sm:inline whitespace-nowrap">Tanggal : <span className="font-semibold text-slate-700 dark:text-slate-200">{detailPenjualan?.created_at}</span></span>
                      </span>
                    </Dialog.Title>
                  </div>
                  <div className="grid gap-2">
                    <div className="border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden bg-slate-50 dark:bg-slate-800/30">
                      <div className="p-3 border-b border-slate-200 dark:border-slate-700 bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-400 font-semibold px-4 sm:px-5">
                        <h2 className="text-sm sm:text-base">Detail Transaksi</h2>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-3 text-sm font-medium text-slate-600 dark:text-slate-300 flex flex-col sm:flex-row justify-between px-4 sm:px-5 sm:items-center gap-1.5 sm:gap-4">
                        <span className="shrink-0">Item</span>
                        <div className="text-slate-900 dark:text-slate-100 text-left sm:text-right">
                          <div className="text-amber-700 dark:text-amber-500 font-bold leading-tight">
                            <span className="text-red-500 dark:text-red-400 font-normal">[ {tgl[0]} ]</span> [ {detailPenjualan?.item?.kode_item} - {detailPenjualan?.item?.jenis_kategori?.nama_jenis} ]{' '}
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-3 text-sm font-medium text-slate-600 dark:text-slate-300 flex flex-row justify-between px-4 sm:px-5 items-center gap-4">
                        <span className="shrink-0">Berat</span>
                        <div className="text-slate-900 dark:text-slate-100 text-right">
                          <div className="px-2.5 py-1 bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300 rounded-md font-bold text-sm inline-block shadow-sm border border-amber-200/50 dark:border-amber-700/50">
                            {detailPenjualan?.item?.berat} Gram
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-3 text-sm font-medium text-slate-600 dark:text-slate-300 flex flex-row justify-between px-4 sm:px-5 items-center gap-4">
                        <span className="shrink-0">Emas</span>
                        <div className="text-slate-900 dark:text-slate-100 text-right">
                          <div className="text-amber-700 dark:text-amber-400 font-bold">{detailPenjualan?.item?.karat} Karat</div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-3 text-sm font-medium text-slate-600 dark:text-slate-300 flex flex-col sm:flex-row sm:justify-between px-4 sm:px-5 sm:items-center gap-1.5 sm:gap-4">
                        <div className="flex flex-col">
                          <span>Harga Modal / gram</span>
                          <span className="text-red-500 dark:text-red-400 text-[10px] font-normal italic">(* Harga modal saat diinput)</span>
                        </div>
                        <div className="text-slate-900 dark:text-slate-100 text-left sm:text-right">
                          <div className="text-amber-700 dark:text-amber-400 font-bold text-base sm:text-sm">
                            Rp {numberWithCommas(detailPenjualan?.item?.harga_modal == undefined ? '0' : detailPenjualan?.item?.harga_modal)}
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-3 text-sm font-medium text-slate-600 dark:text-slate-300 flex flex-col sm:flex-row sm:justify-between px-4 sm:px-5 sm:items-center gap-1.5 sm:gap-4">
                        <div className="flex flex-col">
                          <span>Harga Jual / gram</span>
                          <span className="text-red-500 dark:text-red-400 text-[10px] font-normal italic">(* Total harga jual dibagi berat)</span>
                        </div>
                        <div className="text-slate-900 dark:text-slate-100 text-left sm:text-right">
                          <div className="text-amber-700 dark:text-amber-400 font-bold text-base sm:text-sm">
                            Rp {numberWithCommas(detailPenjualan?.item?.harga_modal == undefined ? '0' : Math.round(harga_modal_jual))}
                          </div>
                        </div>
                      </div>
                      <div className="border-b border-slate-200 dark:border-slate-700/50 py-3.5 text-sm font-bold text-slate-700 dark:text-slate-200 flex flex-row justify-between px-4 sm:px-5 items-center bg-amber-50/50 dark:bg-slate-800/80 gap-4">
                        <span className="shrink-0 text-slate-600 dark:text-slate-400 uppercase text-xs tracking-wider">Total Harga</span>
                        <div className="text-right">
                          <div className="text-amber-600 dark:text-amber-400 text-lg sm:text-base font-extrabold tracking-tight">
                            Rp {numberWithCommas(detailPenjualan?.total_harga == undefined ? '0' : detailPenjualan?.total_harga)}
                          </div>
                        </div>
                      </div>
                      <div className="py-3 text-sm font-medium text-slate-600 dark:text-slate-300 flex flex-col sm:flex-row sm:justify-between px-4 sm:px-5 sm:items-center gap-2 sm:gap-4">
                        <div className="flex flex-col flex-1">
                          <span>Laba Penjualan</span>
                          <span className="text-red-500 dark:text-red-400 text-[10px] font-normal italic leading-snug">(* Jika minus (RUGI) dan jika plus (UNTUNG))</span>
                        </div>
                        <div className="text-slate-900 dark:text-slate-100 text-left sm:text-right shrink-0">
                          <div className={`font-bold text-base sm:text-sm py-1.5 px-3 rounded-lg border ${detailPenjualan?.laba < 0 ? 'text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/10 border-red-100 dark:border-red-900/30' : 'text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/10 border-emerald-100 dark:border-emerald-900/30'}`}>
                            Rp {numberWithCommas(detailPenjualan?.laba == undefined ? '0' : Math.round(detailPenjualan?.laba))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 text-sm font-semibold text-slate-700 dark:text-slate-200 px-1 border border-transparent">
                      Gambar
                      <div className="mt-2 overflow-hidden">
                        {/* {isOpen && (
                            <PhotoView src={
                              detailPenjualan?.item?.gambar1 === null
                                ? ''
                                : `${imageBaseUrl}${detailPenjualan?.item?.gambar1[0].asli}`
                            }>
                              <img src={
                                detailPenjualan?.item?.gambar1 === null
                                  ? ''
                                  : `${imageBaseUrl}${detailPenjualan?.item?.gambar1[0].asli}`
                              } alt="" width={'80px'}
                                height={'80px'} srcSet="" />
                            </PhotoView>
                          )} */}
                        {isOpen && (
                          <ImageComponent
                            onClick={() => setOpenImage(true)}
                            className={'max-w-[80px]  hover:scale-110 cursor-pointer'}
                            width={'80px'}
                            height={'80px'}
                            style={{ objectFit: 'cover' }}
                            src={
                              detailPenjualan?.item?.gambar1 === null
                                ? ''
                                : `${imageBaseUrl}${detailPenjualan?.item?.gambar1[0].asli}`
                            }
                          />
                        )}
                      </div>
                    </div>
                    <div className="mt-5 pt-5 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-end gap-3">
                      <button
                        onClick={closeModal}
                        className="w-full sm:w-auto order-2 sm:order-1 px-5 py-2.5 text-sm font-semibold text-slate-700 bg-white border border-slate-300 hover:bg-slate-50 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600 dark:hover:bg-slate-700 rounded-xl shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-slate-200"
                      >
                        Tutup
                      </button>
                      <ReactToPrint
                        trigger={() => (
                          <button className="w-full sm:w-auto order-1 sm:order-2 px-5 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 shadow-md hover:shadow-lg transition-all focus:outline-none rounded-xl inline-flex items-center justify-center gap-2">
                            <IconPrinter size={18} stroke={2.5} />
                            Cetak Struk
                          </button>
                        )}
                        content={() => compSurat.current}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
